import list from "./list";
import listRob from "./listRob";
import show from "./show";

export default {
  namespaced: true,
  modules: {
    list,
    show,
    listRob,
  },
};
